import { Cell, Bar, YAxis, XAxis, CartesianGrid, Tooltip, ReferenceLine, ResponsiveContainer, ComposedChart, LabelList } from 'recharts';
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'reactstrap';

export const BenchmarkChart = (props) => {
  const {
    isOpen = false,
    setModal,
    chartData,
    chartTitle,
    chartExtra,
    toggleChartSort,
    sortChartBy
  } = props;

  let description = `${chartExtra.value} ${chartExtra.metric_name} for ${chartExtra.property_name} property based on ${chartExtra.column_tag} Probes for ${chartExtra.period_description}`;
  if (!chartExtra.property_name) {
    description = null;
  }

  const copyToClipboard = () => {
    // Iterate through row arrays and return comman-delimited strings
    const rows = chartData.map(dataRow => {
      const csvRow = Object.keys(dataRow).map(key => dataRow[key]).join(',');
      return csvRow.replace(/.$/,'');
    });

    // Copy to clipboard
    navigator.clipboard.writeText(rows.join('\n'));
  };

  const renderPeriodLegend = () => chartExtra?.periods?.map((period, index) => <div className="mr-2 ml-2" key={index} style={{color: period.colour}}>{period.probe_period}</div>);

  return (
    <Modal isOpen={isOpen} className="w80-modal mt-3" >
      <ModalHeader className="bg-primary text-white border-top border-primary">
        {chartTitle}
      </ModalHeader>
      <ModalBody className="p-0">
        {description && (
          <div className="p-2 bg-lightgray text-center">{description}</div>
        )}

        <div style={{ width: '100%', height: 500, padding: 1}}>
          <ResponsiveContainer >
            <ComposedChart
              layout="vertical"
              data={chartData}
              margin={{
                top: 20,
                right: 20,
                bottom: 20,
                left: 20,
              }}
            >
              <CartesianGrid stroke="#f5f5f5" />
              <ReferenceLine x={chartExtra.rawValue} stroke="#cc0000" />
              <ReferenceLine x={0} stroke="#413ea0" />
              <XAxis type="number" dataKey="value" style={{fontSize: 12}} tickFormatter={tick => {return tick.toLocaleString()}} unit={chartExtra?.unit_attributes?.suffix} />
              <YAxis dataKey="name" type="category" scale="band" width={250} style={{fontSize: 12}} interval={0}/>
              <Tooltip formatter={(value) => `${value.toLocaleString()}${chartExtra.unit_attributes.suffix}`} />

              <Bar dataKey="value" barSize={20} fill="#413ea0" >
                {
                  chartData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={entry.colour} />
                  ))
                }
              </Bar>
            </ComposedChart>
          </ResponsiveContainer>
        </div>
        <div className="d-flex justify-content-center">
          {renderPeriodLegend()}
        </div>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Button size="sm" color="light" onClick={() => setModal(false)}>
          Close
        </Button>

        <Button size="sm" color="warning" onClick={copyToClipboard}>
          Copy to Clipboard
        </Button>

        {chartExtra.showChartSort && (
          <Button size="sm" color="link" onClick={toggleChartSort}>
            Sort By {(sortChartBy === 'property' ? 'Period' : 'Property')}
          </Button> 
        )}
      </ModalFooter>
    </Modal>
  );
};
